module.exports = __webpack_public_path__ + "static/media/mall-discount-bg-green.021c3cf8.svg";